import './public//assets/css/App.css';
import {Home} from "./screens/home.tsx";
import {Loading} from "./components/loading.tsx";
import {Intro} from "./screens/intro.tsx";
import {SelectAvatar} from "./screens/select-avatar.tsx";
import {RateActivity} from "./screens/rate-activity.tsx";
import {ConfirmActivity} from "./screens/confirmActivity.tsx";
import {FinalActivites} from "./screens/finalActivites.tsx";
import {SelectSkill} from "./screens/selectSkill.tsx";
import {FinalAvatar} from "./screens/finalAvatar.tsx";
import {
    MemoryRouter,
    Routes,
    Route
} from "react-router";
import {GeneralContextProvider} from "./contexts/Gneral.tsx";
import {ActivityContextProvider} from "./contexts/Activity.tsx";

export function App() {
  return (
      <MemoryRouter initialEntries={['/']}>
          <GeneralContextProvider>
              <ActivityContextProvider>
                  <Routes>
                      <Route path={'/'} element={<Home></Home>}/>
                      <Route path={'/intro'} element={<Intro></Intro>}/>
                      <Route path={'/select-avatar'} element={<SelectAvatar></SelectAvatar>}/>
                      <Route path={'/select-activity'} element={<RateActivity></RateActivity>}/>
                      <Route path={'/confirm-activity'} element={<ConfirmActivity></ConfirmActivity>}/>
                      <Route path={'/activities-final'} element={<FinalActivites></FinalActivites>}/>
                      <Route path={'/select-skill'} element={<SelectSkill></SelectSkill>}/>
                      <Route path={'/final'} element={<FinalAvatar></FinalAvatar>}/>
                  </Routes>
              </ActivityContextProvider>
          </GeneralContextProvider>
      </MemoryRouter>
  );
}
